import moment from "moment-timezone";
import pluralize from "pluralize";
import { convertFromServerTime, convertToServerTime, formatDateString } from "../../../../utils";
import { DateTimeRange, DateTimeRangeMode } from "./DateTimeRangeType";

export function formatDateTimeRangeValue(
  value: DateTimeRange | undefined | null,
  dateFormat: string,
  dateTimeFormat: string,
  timeZone: string,
  serverTimeZone: string,
  serverDataTimeFormatMoment: string) {


  if (value) {
    switch (value.mode) {
      case DateTimeRangeMode[DateTimeRangeMode.date]:
        return formatDateString(value.date, dateFormat, timeZone, serverTimeZone, serverDataTimeFormatMoment);
      case DateTimeRangeMode[DateTimeRangeMode.range]: {
        const formattedFrom = formatDateString(value.from || new Date(), dateTimeFormat, timeZone, serverTimeZone, serverDataTimeFormatMoment);
        const formattedTo = formatDateString(value.to || new Date(), dateTimeFormat, timeZone, serverTimeZone, serverDataTimeFormatMoment);

        if (value.from && value.to) {
          return `${formattedFrom} - ${formattedTo}`;
        } else if (value.from) {
          return `From: ${formattedFrom}`;
        } else if (value.to) {
          return `To: ${formattedTo}`;
        }
        break;
      }
      case  DateTimeRangeMode[DateTimeRangeMode.last]:
        if (value.amount) {
          return `${value.amount} ${pluralize(value.period, value.amount || 1)}`;
        }
        break;
      case  DateTimeRangeMode[DateTimeRangeMode.empty]:
        return "Empty";
      default:
        return "Unsupported";
    }
  }
  return "";
}

export function formatDateTimeRangeValueToObject(
  value: DateTimeRange | undefined | null,
  serverDateTimeFormat: string,
  timeZone: string,
  serverTimeZone: string): { from?: string, to?: string } | null | undefined {

  switch (value?.mode) {
    case DateTimeRangeMode[DateTimeRangeMode.date]: {
      if (value.date) {
        return {
          from: convertToServerTime(convertFromServerTime(value?.date, serverTimeZone, serverDateTimeFormat)
            .tz(timeZone)
            .startOf("day"), serverTimeZone, serverDateTimeFormat),
          to: convertToServerTime(convertFromServerTime(value?.date, serverTimeZone, serverDateTimeFormat)
            .tz(timeZone)
            .endOf("day"), serverTimeZone, serverDateTimeFormat),
        };
      }
      break;
    }
    case DateTimeRangeMode[DateTimeRangeMode.range]: {
      if (value.from || value.to) {
        return {
          from: value.from || undefined,
          to: value.to || undefined,
        };
      }
      break;
    }
    case DateTimeRangeMode[DateTimeRangeMode.last]: {
      if (value.amount && value.period) {
        return {
          from: convertToServerTime(moment(new Date())
            .subtract(value.amount, value.period), serverTimeZone, serverDateTimeFormat),
        };
      }
      break;
    }
    case "empty":
      return null;
  }
  return undefined;
}
